export interface IProduct{
    id: number;
    name: string;
    type: string;
    image: string;
    longDescription: string;
    specs?: ISpecs;
}

export interface ISpecs {
    actuationForce: string;
    actuationPoint: string;
    bottomOut: string;
    bottomOutTravel: string;
    price: string;
}

export class Collection {
    handleItemClicked(id: number) {}
    items: IProduct[] = [
        {
            id: 1,
            name: "Holy Panda",
            type: "Tactile",
            image:  "/images/holy_panda.png",
            longDescription: "With a name like Holy Panda, these switches had to be epic.\
                Made with stems from Halo Clears or Halo Trues, with the housing found on Invyr Panda switches,\
                Holy Panda switches combine the best of two worlds. The result is a snappy,\
                tactile switch that is satisfying to type on. This time around we won't be pre-lubing the switches.\
                As the original tooling is too damaged to make a new run, this batch will be made with updated tooling.\
                It's also worth noting that due to the opaque housing, they won't let as much per-switch lighting through as some switches.",
            specs: {
                actuationForce: "44",
                actuationPoint: "2.4",
                bottomOut: "62",
                bottomOutTravel: "3.8",
                price: "1.60"
            }
        },
        {
            id: 2,
            name: "Gazzew Boba",
            type: "Tactile",
            image:  "/images/gazzew_boba.png",
            longDescription: "Gazzew Boba U4 silent tactile switches are a new switch with a large,\
                smooth \"D\" shaped tactile bump with no pre-travel.\
                The Pearl White base is made of a new plastic that is softer than regular Nylon with the benefits of Polycarbonate.\
                The top housing is designed to reduce wobble and they feature a universal base designed to work with PCB mounted RGBs and \
                all in switch LEDs. The leaf is designed to increase tactility while reducing ping through the use of new materials.\
                These Switches also come with Korean-made stainless springs designed to have minimal ping,\
                giving you a nearly silent typing experience.",
            specs: {
                actuationForce: "44",
                actuationPoint: "2.4",
                bottomOut: "62",
                bottomOutTravel: "3.8",
                price: "0.98"
            }
        },
        {
            id: 3,
            name: "Kiwis",
            type: "Tactile",
            image:  "/images/kiwis.png",
            longDescription: "The Kiwi switches are the newest member of the Fruit Switch Family,\
                joining our community fave Tangerine Switches. They are 67g Tactile with a T1 stem, Lightly factory lubed,\
                Translucent bright green with N9 Grey stem, Proprietary C^3 Equalz top housing design (same as Tangerine Switches),\
                Gold-plated internals",
            specs: {
                actuationForce: "44",
                actuationPoint: "2.4",
                bottomOut: "67",
                bottomOutTravel: "3.8",
                price: "0.95"
            }
        },
        {
            id: 4,
            name: "Novelkeys Blueberry",
            type: "Tactile",
            image:  "/images/novelkey_blueberry.png",
            longDescription: "Tactile switch featuring the same material as the Cream switches. \
                Very long tactile bump that ends at 3mm, which is the actuation point.",
            specs: {
                actuationForce: "55",
                actuationPoint: "3",
                bottomOut: "80",
                bottomOutTravel: "4",
                price: "1.08"
            }
        },
        {
            id: 5,
            name: "Zealios 67g",
            type: "Tactile",
            image:  "/images/zealios.png",
            longDescription: "All Zealio V2 have reduced wobble that's less than Holy Pandas, \
                while managing to be even more tactile with a bigger, smoother bump as well. \
                Bump starts at the very top of the keypress, no pre-travel.",
            specs: {
                actuationForce: "30",
                actuationPoint: "2.4",
                bottomOut: "67",
                bottomOutTravel: "4",
                price: "1.55"
            }
        },
        {
            id: 6,
            name: "Zilent 62g",
            type: "Tactile",
            image:  "/images/zilent_62.png",
            longDescription: "Smooth, long, drawn out tactile bump from the top. Nice cushion during bottom out",
            specs: {
                actuationForce: "20",
                actuationPoint: "2.4",
                bottomOut: "62",
                bottomOutTravel: "4",
                price: "1.80"
            }
        },
        {
            id: 7,
            name: "Zilent 67g",
            type: "Tactile",
            image:  "/images/zilent_67.png",
            longDescription: `"Crisp & responsive" tactile bump feeling at the very top with more cushion during bottom out than 65g Zilent V2`,
            specs: {
                actuationForce: "30",
                actuationPoint: "2.4",
                bottomOut: "67",
                bottomOutTravel: "4",
                price: "1.80"
            }
        },
        {
            id: 8,
            name: "Gateron Brown",
            type: "Tactile",
            image:  "/images/gateron_brown.png",
            longDescription: "A hybrid between Linear and Clicky switches. Does not generate a click when pressed, \
                but the tactile bump is still present. Ideal for those who want a tactile bump and work around peers",
            specs: {
                actuationForce: "30",
                actuationPoint: "2.4",
                bottomOut: "67",
                bottomOutTravel: "4",
                price: "0.85"
            }
        },
        {
            id: 9,
            name: "Cherry Red",
            type: "Linear",
            image:  "/images/cherry.png",
            longDescription: "The CHERRY MX Red is the first choice for beginners in the world of mechanical keyboards. \
                The smooth-running CHERRY MX technology enables balanced writing and gaming sessions.",
            specs: {
                actuationForce: "45",
                actuationPoint: "2.0",
                bottomOut: "60",
                bottomOutTravel: "4",
                price: "1.00"
            }
        },
        {
            id: 10,
            name: "Gateron Clear",
            type: "Linear",
            image:  "/images/gateron_clear.png",
            longDescription: "The lightest switch available, ideal for people who prefer a softer touch. Minimizes finger fatigue.",
            specs: {
                actuationForce: "35",
                actuationPoint: "2.2",
                bottomOut: "35",
                bottomOutTravel: "4",
                price: "0.85"
            }
        },
        {
            id: 11,
            name: "Gateron Red",
            type: "Linear",
            image:  "/images/holy_panda.png",
            longDescription: "The ideal switch preferred by gamers, allowing rapid execution of the keys.",
            specs: {
                actuationForce: "45",
                actuationPoint: "2.4",
                bottomOut: "55",
                bottomOutTravel: "4",
                price: "0.85"
            }
        },
        {
            id: 12,
            name: "Mauve Linear",
            type: "Linear",
            image:  "/images/mauve.png",
            longDescription: "Mauve & Lilac  linears are the familiar JWK linears we have come to know and love. \
                incredibly smooth stock but even better with lubes and films - JWK switches love to be filmed for the best sound.",
            specs: {
                actuationForce: "40",
                actuationPoint: "2.0",
                bottomOut: "65",
                bottomOutTravel: "4",
                price: "0.96"
            }
        }
    ]
}